import styled from "styled-components"
import { ButtonLabel, FlexRowCenter, Spacer } from "../../atoms/Atoms"
import { SinglePathSVG } from "../../SVG"
import React from "react"
import { carrotOrange } from "css/variables/_colors.scss"
import L10n from "../../../../lib/carrot-l10n"
import { Button } from "../../atoms/buttons/Button"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const StyledMobileTalkToCarrot = styled.div`
  pointer-events: none;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  height: 96px;
  padding-top: 24px;
  z-index: 1;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 100%);
`

const MobileChatBubble = () => (
  <SinglePathSVG strokeWidth={1.5} stroke={carrotOrange} fill="transparent" icon="chatBubble" />
)

export const MobileTalkToCarrot = () => (
  <StyledMobileTalkToCarrot>
    <FlexRowCenter>
      {/* Clear the hover background, otherwise the very-light-orange background stays permanently after tapping on mobile */}
      <Button to="/talk-to-carrot" hoverBackgroundColor={null}>
        <div className="pv1 flex items-center">
          <MobileChatBubble />
          <Spacer width={1} />
          <ButtonLabel>{l`Talk to Carrot`}</ButtonLabel>
        </div>
      </Button>
    </FlexRowCenter>
  </StyledMobileTalkToCarrot>
)
